import { cn } from '@commenda/utils';
import React from 'react';

import { TruncatedText } from '../../TruncatedText';

export interface DataGridCellTextDescriptionProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  leading?: React.ReactNode;
  className?: string;
}

const DataGridCellTextDescription = ({
  title,
  description,
  leading,
  className,
}: DataGridCellTextDescriptionProps) => (
  <div className={cn('flex w-full items-center gap-lg', className)}>
    {leading}
    <div className="flex min-w-0 flex-1 flex-col">
      <TruncatedText className="txt-small-medium text-text-primary">
        {title}
      </TruncatedText>
      {description ? (
        <TruncatedText className="txt-extra-small-regular text-text-tertiary">
          {description}
        </TruncatedText>
      ) : null}
    </div>
  </div>
);

export { DataGridCellTextDescription };
